export default "__VITE_ASSET__720ab95e__"